import type {
  ArenaFairPlayHistoryItem,
  ArenaMatchResult,
  ArenaRankingEntry,
  ArenaResultDispute,
} from "@/types/services/api-contracts";

import { callEdgeData } from "./_core/edge-call";
import { ARENA_FUNCTION_NAME } from "./_core/function-names";

export const arenaResultsService = {
  async submitMatchResult(data: {
    match_id: string;
    winner_group_id?: string | null;
    loser_group_id?: string | null;
    draw?: boolean;
    no_show_group_id?: string | null;
    score_summary?: string;
  }): Promise<ArenaMatchResult> {
    return callEdgeData<ArenaMatchResult>(ARENA_FUNCTION_NAME, "submit-match-result", {
      body: data,
    });
  },

  async confirmMatchResult(data: {
    match_id: string;
    confirm: boolean;
    contested_reason?: string;
  }): Promise<ArenaMatchResult> {
    return callEdgeData<ArenaMatchResult>(ARENA_FUNCTION_NAME, "confirm-match-result", {
      body: data,
    });
  },

  async disputeMatchResult(data: {
    match_id: string;
    reason: string;
  }): Promise<ArenaResultDispute> {
    return callEdgeData<ArenaResultDispute>(ARENA_FUNCTION_NAME, "dispute-match-result", {
      body: data,
    });
  },

  async resolveMatchDispute(data: {
    dispute_id: string;
    resolution_kind: "uphold_result" | "reopen_confirmation";
    resolution_notes?: string;
  }): Promise<ArenaResultDispute> {
    return callEdgeData<ArenaResultDispute>(ARENA_FUNCTION_NAME, "resolve-match-dispute", {
      body: data,
    });
  },

  async listTeamFairPlayHistory(groupId?: string): Promise<ArenaFairPlayHistoryItem[]> {
    return callEdgeData<ArenaFairPlayHistoryItem[]>(ARENA_FUNCTION_NAME, "list-team-fair-play-history", {
      method: "GET",
      params: groupId ? { group_id: groupId } : undefined,
    });
  },

  async getRanking(filters?: {
    sport_id?: string;
    city?: string;
  }): Promise<ArenaRankingEntry[]> {
    return callEdgeData<ArenaRankingEntry[]>(ARENA_FUNCTION_NAME, "get-ranking", {
      method: "GET",
      params: {
        ...(filters?.sport_id ? { sport_id: filters.sport_id } : {}),
        ...(filters?.city ? { city: filters.city } : {}),
      },
    });
  },
};
